import pendingUsers from "./pendingUsers";
import i18n from "./i18n";

export default {
  pendingUsers,
  i18n
};
